module.exports = __webpack_public_path__ + "img/portfolio_7.92aceeae.jpg";